import { render, staticRenderFns } from "./CallHistory.vue?vue&type=template&id=92aae03a&scoped=true"
import script from "./CallHistory.vue?vue&type=script&lang=js"
export * from "./CallHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92aae03a",
  null
  
)

export default component.exports